import { render, staticRenderFns } from "./NeighbourMetaTable.vue?vue&type=template&id=42e460da&"
import script from "./NeighbourMetaTable.vue?vue&type=script&lang=js&"
export * from "./NeighbourMetaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports